<div class="container-fluid section pt-3 pb-2">
    <span class="header">Booked midwives</span>
    <div class="sub-section py-2 px-3 my-2" *ngIf="booking">
        <div class="d-flex flex-row">
            <img class="profile-img" *ngIf="booking.midwifeBooked[0].profileImage"
                [src]="booking.midwifeBooked[0].profileImage">
            <img class="profile-img" *ngIf="!booking.midwifeBooked[0].profileImage"
                src="../../../../../../assets/Images/pro-pic.png">
            <div class="d-flex flex-column ml-3 mt-1">
                <span class="title">{{booking.midwifeBooked[0]?.name}}</span>
                <span class="sub-title mt-1" *ngIf="booking?.nextVisitDate">Next visit:
                    {{booking?.nextVisitDate | date:'EEE dd MMM'}}</span>
                <span class="sub-title mt-1" *ngIf="!booking?.nextVisitDate">{{booking?.startDate | date:'EEE
                    dd MMM'}} - {{booking?.endDate | date:'EEE dd MMM'}}</span>
            </div>
        </div>
        <div class="d-flex flex-row mt-3 mb-2">
            <i class="fas fa-phone icon phone"></i>
            <span class="section-text ml-3">{{booking.midwifeBooked[0].user[0]?.userPhonenumber}}</span>
        </div>
        <div class="d-flex flex-row my-2">
            <i class="fas fa-envelope icon"></i>
            <span class="section-text ml-3">{{booking.midwifeBooked[0].user[0]?.userEmail}}</span>
        </div>
        <div class="d-flex flex-row mt-3 justify-content-end" *ngIf="status == bookingStatus.NOT_COMPLETED"
            (click)="viewDetail()">
            <span class="navigate-text mr-2">VIEW DETAILS</span>
            <i class="fas fa-long-arrow-alt-right arrow-icon"></i>
        </div>
        <button class="btn btn-theme-inverse btn-block mt-3 mb-2" *ngIf="status == bookingStatus.COMPLETED"
            data-toggle="modal" data-target="#rate-midwife">Rate Now</button>
        <button class="btn btn-theme-inverse btn-block my-2" *ngIf="status == bookingStatus.COMPLETED"
            data-toggle="modal" data-target="#write-testimonial-confirm">Write
            Testimonial</button>
    </div>
    <div class="no-data pt-5" *ngIf="!booking">
        <img class="align-self-center" src="../../../../../../assets/Images/NoDocuments.png" height="50" width="80"
            alt="No Midwife Booked">
        <span>No midwife booked</span>
    </div>
</div>

<!-- Write Testimonial Modal Begins -->
<app-write-testimonial [midwife]="booking.midwifeBooked[0]" *ngIf="status == bookingStatus.COMPLETED">
</app-write-testimonial>
<!-- Write Testimonial Modal Ends -->

<!-- Rate Midwife Modal Begins -->
<app-rate-midwife [midwife]="booking.midwifeBooked[0]" *ngIf="status == bookingStatus.COMPLETED"></app-rate-midwife>
<!-- Rate Midwife Modal Ends -->

<app-view-booking></app-view-booking>